/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_CheckInputs */

const cs_portals_check = /** @type {(inputs: Portals_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkontrolovat`)
};

const en_portals_check = /** @type {(inputs: Portals_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check`)
};

/**
* | output |
* | --- |
* | "Check" |
*
* @param {Portals_CheckInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check = /** @type {((inputs?: Portals_CheckInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_CheckInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check(inputs)
	return cs_portals_check(inputs)
});